module.exports = __webpack_public_path__ + "img/mobile_index_banner_4.8444dea0.jpg";